import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store';
import { dismissToast } from '@/store/uiSlice';

const TONES: Record<string, string> = {
  success: 'border-jade bg-jade-soft text-ink',
  error: 'border-rust bg-rust-soft text-ink',
  info: 'border-rule bg-white text-ink'
};

export function Toasts() {
  const toasts = useAppSelector((state) => state.ui.toasts);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const timers = toasts.map((toast) =>
      setTimeout(() => dispatch(dismissToast(toast.id)), 5000)
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts, dispatch]);

  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-50 flex w-80 flex-col gap-2"
      role="status"
      aria-live="polite"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`rounded border px-3 py-2.5 text-small shadow-pop ${TONES[toast.tone]}`}
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
}
